import { Nullable } from 'common/types/nullable';
import { DebugTallyTracker } from './DebugTallyTracker';

/** Row count type enum. */
export enum RowCountType {
  Total = 'total',
  Filtered = 'filtered',
}

/** Individual count result with async state. */
export interface AsyncRowCount {
  value: Nullable<number>;
  loading: boolean;
  error: Nullable<string>;
  refetch: () => Promise<Nullable<number>>;
}

/** Context value interface with separate async values for each count type. */
export interface RowCountValue {
  totalCount: AsyncRowCount;
  filteredCount: AsyncRowCount;
  debugTracker: Nullable<DebugTallyTracker>;
}
